import { PERSIST } from "./persist.config";

const KEY = "__agent_enquiry_portal_store_v1__";

export const loadState = () => {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : undefined;
  } catch {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const subset = {};
    Object.entries(PERSIST).forEach(([slice, shouldPersist]) => {
      if (shouldPersist) subset[slice] = state[slice];
    });
    sessionStorage.setItem(KEY, JSON.stringify(subset));
  } catch {}
};

export const clearState = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch {}
};
